import React from 'react'

import { type Question } from '~/hooks/useSurveyQuery'
import { type ColumnInfo } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'
import { buildMatrixTableColumns, type MatrixColumnKey } from '../utils'

export const useMatrixTableColumns = (
  question: Question,
): ColumnInfo<MatrixColumnKey>[] => {
  const questionsDiffsMap = useAtomValueContext('questionsDiffsMap')
  const hiddenColumnKeys = useAtomValueContext('hiddenColumnKeys')

  return React.useMemo(
    () =>
      buildMatrixTableColumns({
        hiddenColumnKeys,
        question,
        questionsDiffsMap,
      }),
    [hiddenColumnKeys, question, questionsDiffsMap],
  )
}
